const removeSpecialChars = str => {
  return str.replace(/[^a-zA-Z\u00C0-\u00FF\d\s]+/gim, '');
};
module.exports = removeSpecialChars;